import React, { FC, CSSProperties } from 'react'
import queryString from 'query-string'
import { Navigate, useLocation } from 'react-router-dom'
import { useOktaAuth } from '@okta/okta-react'
import { routes } from 'config'
import { constants, deleteCookie, getCookieVal, isMultiLoginApp } from 'utils'
import { BaseLayout, Module } from 'components'
import { LoggingOut, LoggedOut } from './components'
import appConfig from 'config/app-config'
// import { CSSProperties } from '@mui/material/styles/withStyles'

console.log(
  `---> IsIframe: ${window.self !== window.top}; Logout page loaded with URL ${window.location.href} and referrer ${document.referrer}`,
)
const handleMultiLoginLogout = (
  values: queryString.ParsedQuery<string>,
  logoutUrlsToUse: string[],
  oktaAuth: ReturnType<typeof useOktaAuth>['oktaAuth'],
): boolean => {
  let isLoggedOutOperationDone = false

  if (values.state != null && values.state === 'complete') {
    isLoggedOutOperationDone = true
  }

  deleteCookie('multiloginuser')

  if (getCookieVal('multiloginuser')?.includes('yes')) {
    console.log(
      `!!!!!  COOKIE IS STILL THERE AFTER DELETION ATTEMPT. multiloginuser cookie value: ${getCookieVal('multiloginuser')}   Referrer: ${document.referrer}  `,
    )
  }
  /*
  * The /logout page is called on the Mulitlogin site (multilogin.brightmls.com) for these reasons:
    1. When the user clicks the Logout button in the MultiLogin UI. This will log out of MultiLogin UI only from the brightmls-imp.okta.com org.
    
    2. When the user is using MultiLogin and changes users.  This is the complete flow:
        1. User clicks the member he wants to log into.  (multilogin.brightmls.com/xxxx
        1a. The lambda xxxx is called to to update the bright-imp.okta.com org with the new memberMlsId
        1b. The page then redirects to the BCOM site  www.brightmls.com/logout?multilogin=1
        2. The BCOM logout page detects the multilogin=1 query param and logs out of BCOM.
        2a. The BCOM logout page then redirects to login.brightmls.com/logout?multilogin=1
        3. The login.brightmls.com/logout page detects the multilogin=1 query param. 
        3.a. that logout page logs out of all other apps (except for the multilogin app) by calling the logout URLs in iFrames.
        3.b. when finished, the login.brightmls.com/impersonategateway page  is called
        4.  The impersonategateway does some magic to log the user into the correct account 
            in the bright-imp.okta.com org based on the memberMlsId that was set in step 1a. There's several
            okta redirects that happens between the brightmls-imp.org and okta.brightmls.com org to sign the new 
            user into the account.
        5. Okta will redirect the user to  www.brightmls.com/dashboard
        6. Since the user is not logged in, it will do the redirections to log into AWS Cognito and then back to the BCOM dashboard but now with the new user that was selected in the MultiLogin UI.

        Important Notes about the flow:
            1. The multilogin=1 query param is only used to indicate that the logout is being triggered 
            from the MultiLogin UI and that we should log out of everything except for 
            the MultiLogin application.  This is because if we log out of the MultiLogin application,
             then we won't be able to continue with the logout process to log out of everything 
             else and then log back in with the new user. 
            2. The multilogin=1 query param is not used to indicate that the user is logged into 
            the MultiLogin application.  The presence of the "multiloginuser" cookie is used for that 
            instead. This is because there are cases where we want to log out of everything except for 
            the MultiLogin application (when multilogin=1) but the user may or may not be logged into
            the MultiLogin application (the "multiloginuser" cookie may or may not be present).

    3. When the user types in https://login.brightmls.com/logou  (no querystring params)
        1. The login.brightmls.com/logout page checks if the user is logged
            in to the MultiLogin application by checking if the "multiloginuser" cookie is present.
        2. If the cookie is present, then the user is logged into the MultiLogin application, 
            so log out of the MultiLogin application first by redirecting to multilogin.brightmls.com/logout?redirect=login.brightmls.com/logout
            1. The multilogin.brightmls.com/logout page will log the user out of the MultiLogin application and then redirect back to login.brightmls.com
                NOTE:  This redirects back to the regular logout page with no query params, so the rest of the normal
                logout process happens. s
        3. If the cookie is not present, then the user is not logged into the MultiLogin application, 
           so continue with the logout process to log out of evrything through iframes.
*/

  // Occurs during normal logout when someone clicks the Logout Button in the menu or someone navigates to login.brightmls.com/logout
  if (values.redirect != null) {
    //signs out and redirects
    console.log(
      `MULTILOGINAPP: URL ${globalThis.location.href}; LOGOUT--> Redirecting to ${values.redirect} after logging out of MultiLogin;   Referrer: ${document.referrer}`,
    )
    oktaAuth.signOut({
      postLogoutRedirectUri: values.redirect,
    })
    console.log(`SHOULD NEVER GET THIS FAR..... Referrer: ${document.referrer}`)
    // just in case the redirect doesn't work, we don't want to continue with the logout process and potentially log the user out of everything when they only wanted to log out of MultiLogin
    isLoggedOutOperationDone = true
  }

  // Log out and then Redirect back to the RedirectURL if the user clicked the button from BCOM or if there are no logout URLs to use
  // (which would be the case if we're in the MultiLogin application because we don't want to log out of the MultiLogin application
  // when logging out from the MultiLogin application, we just want to show the logged out message).
  if (values.multilogin === '1' || logoutUrlsToUse.length === 0) {
    console.log(
      `MULTILOGINAPP: URL ${globalThis.location.href}; LOGOUT--> MULTILOGIN=1; isloggedoutoperation=true   Referrer: ${document.referrer}`,
    )
    isLoggedOutOperationDone = true
  } else if (values.silent != null && values.silent === '1') {
    console.log(
      `MULTILOGINAPP: URL ${globalThis.location.href}; LOGOUT--> Silent=1; isloggedoutoperation=true   Referrer: ${document.referrer}`,
    )
  } else {
    console.log(
      `MULTILOGINAPP: URL ${globalThis.location.href}; LOGOUT--> should be regular logout; isloggedoutoperation=true   Referrer: ${document.referrer}`,
    )
  }

  //Finally, if we're not done logging out, then log out.
  if (!isLoggedOutOperationDone) {
    oktaAuth.signOut({
      postLogoutRedirectUri: globalThis.location.origin + routes.logout,
      state: 'complete',
    })
  }

  return isLoggedOutOperationDone
}

const Logout: FC = () => {
  console.log(
    `Logout page loaded with URL ${globalThis.location.href} and referrer ${document.referrer}`,
  )
  const { oktaAuth } = useOktaAuth()
  const location = useLocation()
  const values = queryString.parse(location.search)

  const hasMultiLoginParam = values.multilogin === '1'
  // Define logout URLs for different environments.
  //There are 3 states where the logoutUrls can be
  // 1. If the Logout is called from the mega menu.  Then, we want to log out of Everything.
  // 2. If the Logout is called because the member is using MultiLogin. It's called from BCOM.  The query pararm will be &multilogin=true)
  // 3. If the Logout is called from the MultiLogin application.
  const devLogoutUrls = appConfig.isMultiLogin
    ? ['']
    : [
        'https://okta.dev.brightmls.com/login/signout',
        // never this one because it points to itself:  'https://login.dev.brightmls.com/logout',
        //  'https://www.dev.brightmls.com/logout?silent=1',
        'https://matrix.dev.brightmls.com/Matrix/logout.aspx',
        'https://apps.dev.brightmls.com/financial/logout',
        'https://lmsedit.dev.brightmls.com/KeyAppSvc/saml/logout',
        'https://apps.dev.brightmls.com/permissions/logout',
        'https://apps.dev.brightmls.com/listingDocuments/logout',
        'https://apps.dev.brightmls.com/publicRecordsWeb/logout',
        'https://brightmls--devmerge.sandbox.my.site.com/customers/secur/logout.jsp', // this doesn't really work because Salesforce doesn't work in DEV but adding for completeness if it's ever fixed
        'https://teams.dev.brightmls.com/logout?silent=1',
        'https://insights.dev.brightmls.com/logout?silent=1',
        'https://brokerapps.dev.brightmls.com/api/logout',
        'https://subscriptionapps.dev.brightmls.com/api/logout',
        'https://showing.dev.brightmls.com/logout',
        'https://laeservices.dev.brightmls.com/auth/logout?silent=1',
        'https://promote.dev.brightmls.com/logout',
      ].filter((url): url is string => url !== undefined)

  const tstLogoutUrls = [
    'https://okta.tst.brightmls.com/login/signout',
    'https://www.tst.brightmls.com/logout?silent=1',
    'https://matrix.tst.brightmls.com/Matrix/logout.aspx',
    'https://apps.tst.brightmls.com/financial/logout',
    'https://lmsedit.tst.brightmls.com/KeyAppSvc/saml/logout',
    'https://apps.tst.brightmls.com/permissions/logout',
    'https://apps.tst.brightmls.com/listingDocuments/logout',
    'https://apps.tst.brightmls.com/publicRecordsWeb/logout',
    'https://brightmls--stage.sandbox.my.site.com/customers/secur/logout.jsp',
    'https://teams.tst.brightmls.com/logout?silent=1',
    'https://insights.tst.brightmls.com/logout?silent=1',
    'https://brokerapps.tst.brightmls.com/api/logout',
    'https://subscriptionapps.tst.brightmls.com/api/logout',
    'https://showing.tst.brightmls.com/logout',
    'https://laeservices.tst.brightmls.com/auth/logout?silent=1',
    'https://promote.tst.brightmls.com/logout',
  ].filter((url): url is string => url !== undefined)

  const prdLogoutUrls = [
    'https://okta.brightmls.com/login/signout',
    'https://www.brightmls.com/logout?silent=1',
    'https://matrix.brightmls.com/Matrix/logout.aspx',
    'https://apps.brightmls.com/financial/logout',
    'https://apps.brightmls.com/permissions/logout',
    'https://apps.brightmls.com/listingDocuments/logout',
    'https://apps.brightmls.com/publicRecordsWeb/logout',
    'https://brightmls.my.site.com/customers/secur/logout.jsp',
    'https://support.brightmls.com/secur/logout.jsp', // this application is in production only
    'https://lmsedit.brightmls.com/KeyAppSvc/saml/logout',
    'https://teams.brightmls.com/logout?silent=1',
    'https://insights.brightmls.com/logout?silent=1',
    'https://brokerapps.brightmls.com/api/logout',
    'https://subscriptionapps.brightmls.com/api/logout',
    'https://showing.brightmls.com/logout',
    'https://laeservices.brightmls.com/auth/logout?silent=1',
    'https://promote.brightmls.com/logout',
  ].filter((url): url is string => url !== undefined)

  let baseLogoutUrls = prdLogoutUrls
  switch (process.env.REACT_APP_LOGOUT_ENVIRONMENT) {
    case 'local':
      baseLogoutUrls = devLogoutUrls
      break
    case 'dev':
      baseLogoutUrls = devLogoutUrls
      break
    case 'tst':
      baseLogoutUrls = tstLogoutUrls
      break
  }

  const logoutUrlsToUse =
    document.referrer === process.env.REACT_APP_DEFAULT_REDIRECTION
      ? [...baseLogoutUrls]
      : [
          `${process.env.REACT_APP_DEFAULT_REDIRECTION}/logout?silent=1`,
          ...baseLogoutUrls,
        ]

  // Clean up session cookies
  sessionStorage.removeItem(
    constants.BROWSER_STORAGE_KEY.LOGGING_OPERATION_DONE,
  )
  localStorage.removeItem('accessToken')
  localStorage.removeItem('okta-cache-storage')
  localStorage.removeItem('okta-original-uri-storage')
  localStorage.removeItem('okta-shared-transaction-storage')
  deleteCookie('alaya_member_login_name')
  let isLoggedOutOperationDone = false

  if (isMultiLoginApp()) {
    isLoggedOutOperationDone = handleMultiLoginLogout(
      values,
      logoutUrlsToUse,
      oktaAuth,
    )
  } else {
    //Perform for the regular logouts
    //"state=complete" is used when the logout process is completed and indicates to display the "You are logged out" message
    if (values.state != null && values.state === 'complete') {
      console.log(
        `REGULARLOGOUT: URL ${globalThis.location.href}; State=Complete;   Referrer: ${document.referrer}`,
      )
      isLoggedOutOperationDone = true
      //"Silent" is used when we want to log out of the current site and not log out of anything else.
      // or if there are no logout URLs to use, then just log out of the current site because there's nothing else to log out of
    } else if (values.multilogin === '1') {
      //continue with the logout because we want to log out of everything if the user is switching users from the MultiLogin UI, but we don't want to log out of everything if the user is just logging out from the MultiLogin application
      console.log('Performing logout for user switching from MultiLogin UI')
      console.log(
        `REGULARLOGOUT: URL ${globalThis.location.href}; Performing Logout for multilogin=1   Referrer: ${document.referrer}`,
      )
    } else if (values.silent != null && values.silent === '1') {
      console.log(
        `REGULARLOGOUT: URL ${globalThis.location.href}; Performing Logout for silent=1   Referrer: ${document.referrer}`,
      )
      oktaAuth.signOut({
        postLogoutRedirectUri: globalThis.location.origin + routes.logout,
        state: 'complete',
      })
    } else if (getCookieVal('multiloginuser')?.includes('yes')) {
      console.log(
        `REGULARLOGOUT: URL ${globalThis.location.href}; Performing Logout for multiloginuser cookie; Redirecting! Referrer: ${document.referrer}`,
      )
      //If the cookie is present, then the user is signed into the multilogin application. Let's log out of that first before logging out of everything else.
      //Note: This url must be setup in the Impersonation Org under Application / Redirec
      globalThis.location.href =
        'https://multilogin.dev.brightmls.com/logout?redirect=' +
        window.location.origin +
        routes.logout
    } else if (window.top !== window) {
      console.log(
        `REGULARLOGOUT: URL ${globalThis.location.href}; Frame Window ignoring;  Referrer: ${document.referrer}`,
      )
      // as per MLSB-3534, special care needs to be taken when logging out of Salesforce
      // Salesforce logout page after logging out of Salesforce must redirect back to /logout
      // since /logout calls Salesforce logout page from iFrame, that redirect from Salesforce to /logout will be in that iFrame
      // if /logout page determines it's in an iframe then it means it was redirected from Salesforce logout page
      // if that's true, then stop processing to avoid a logout loop
      return null
    }
  }

  //Temporary Only
  console.log(
    `Logout URLs to use: ${logoutUrlsToUse} ; QsMultiLogin: ${values.multilogin}; QsSilent: ${values.silent}; Referrer: ${document.referrer}`,
  )

  const logout = async () => {
    if (values.multilogin === '1') {
      window.location.href = `${globalThis.location.origin}/impersonategateway`
    } else if (values.silent === '1') {
      return null
    } else {
      await oktaAuth.signOut({
        postLogoutRedirectUri: window.location.origin + routes.logout,
        state: 'complete',
      })
      localStorage.removeItem('okta-cache-storage')
      localStorage.removeItem('okta-original-uri-storage')
      localStorage.removeItem('okta-shared-transaction-storage')
    }
  }

  const iframeStyle: CSSProperties = {
    width: '1px',
    height: '1px',
    visibility: 'hidden',
  }

  interface loadMap {
    [frameName: string]: boolean
  }
  let frameLoadState: loadMap = {}

  const frameLoaded = async (
    event: React.SyntheticEvent<HTMLIFrameElement, Event>,
  ) => {
    frameLoadState[event.currentTarget.src] = true

    // Check if we've finished loading all iFrames
    let allLoaded = true
    let frameSrc: string
    for (frameSrc of logoutUrlsToUse) {
      console.log(
        `Checking if frame with src ${frameSrc} has loaded: `,
        frameLoadState[frameSrc],
      )
      if (!frameLoadState[frameSrc]) {
        allLoaded = false
        break
      }
    }
    if (allLoaded) {
      // Now that we've attempted to log out of every application (ignoring any error responses)
      // log out of the login application and the IdP itself
      setTimeout(function () {
        console.log('Waiting for all to logout')
        logout()
      }, 1500)
    }
  }

  return (
    <BaseLayout>
      <Module>
        {(() => {
          if (
            sessionStorage.getItem(
              constants.BROWSER_STORAGE_KEY.IS_INACTIVE_MEMBER,
            )
          ) {
            return <Navigate to={{ pathname: routes.membershipExpired }} />
          } else if (isLoggedOutOperationDone) {
            return <LoggedOut />
          } else {
            return (
              <div>
                <LoggingOut />
                {logoutUrlsToUse.map((url, index) => (
                  <iframe
                    title={`LogoutFrame${index}`}
                    key={`frame${index}`}
                    style={iframeStyle}
                    src={url}
                    onLoad={frameLoaded}
                    referrerPolicy="unsafe-url"
                  />
                ))}
              </div>
            )
          }
        })()}
      </Module>
    </BaseLayout>
  )
}

export default Logout
